import React from 'react';
import { People, Chat, } from '@mui/icons-material';
import { useSelector } from 'react-redux';

function HomeSupport({id}){
    
    const userName = useSelector((user) => user.user.info.customer_full_heading)
    const customerCode = useSelector((user) => user.user.info.customer_code)
    const splitName = userName !== null ? userName.split(' ') : null
    
    const link = `https://wa.me/393935777481?text=Ciao%20sono%20${splitName[0]},%20${customerCode}.%20Ti%20contatto%20in%20merito%20al%20movimento%20ID:%20${id}`
    const groupUrl = `https://www.facebook.com/groups/revolucionari.it` 

    return(
        <div className='home-support'>
            <div className='header-row'>
                <h3>Supporto</h3>
            </div>
            <div className='support-list'>
                <div className='icon-support' style={{background:'rgba(90, 216, 166, 0.4)', color: '#5AD8A6'}}>
                    <People></People>
                </div>
                <div className='text-support'>
                    <a rel="noreferrer" target="_blank" href={groupUrl}>
                        Chiedi alla community
                    </a>
                </div>
            </div>
            <div className='support-list'>
                <div className='icon-support' style={{background:' rgba(0, 160, 233, 0.3)', color: '#00A0E9'}}>
                    <Chat></Chat>
                </div>
                <div className='text-support'>
                    <a rel="noreferrer" target="_blank" href={link}>
                        Chatta con noi
                    </a>
                </div>
            </div>
            {/* <div className='support-list'>
                <div className='icon-support' style={{background:' rgba(247, 147, 26, 0.3)', color: '#000000'}}>
                    <AlternateEmail></AlternateEmail>
                </div>
                <div className='text-support'>
                    Apri un ticket
                </div>
            </div> */}
        </div>


    );

}
export default HomeSupport;